import { ButtonBase } from ".";
import { ACTION_STATUS } from "..";

export class CancelButtonModel extends ButtonBase {
    label: string = 'Cancel';
    action: string = ACTION_STATUS.cancel;
    matIconName: string = 'clear';
    colorClass: string = 'color-danger-500';
}